<div class="container-fluid p-3 bg-amber-50">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ payload?.proposal_name }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">



        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <form [formGroup]="proposalForm" class="w-full  mx-auto my-8 ">
    <div class="space-y-6">

      <div
        class="bg-amber-100 border-2 border-gray-300 rounded-lg overflow-hidden transition-all duration-200 hover:shadow-md">

        <div class="p-4 bg-gray-100/90">

          <div class="flex flex-col md:flex-row md:items-center gap-3">

            <!-- Label -->
            <label for="nomenclature" class="text-sm font-medium text-slate-700 md:w-1/4 whitespace-nowrap">
              <span *ngIf="isMakeScheme()"
                class="mr-1">1.</span> Nomenclature <span class="text-red-500">*</span>
            </label>

            <!-- Input + Error -->
            <div class="flex-1">
              <input pInputText id="nomenclature" formControlName="nomenclature" autocomplete="off" class="w-full px-4 py-2.5 border-2 border-slate-400 rounded-md 
                              focus:ring-2 focus:ring-blue-500 focus:border-transparent 
                              transition-all" />


            </div>

          </div>

        </div>
      </div>
      <!-- === Collapsible Section: Basic Information === -->
      <div class="border  overflow-hidden shadow-sm bg-white">
        <div
          class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleSection('basicInfo')">
          <!-- <h3 class="flex-1 text-lg font-bold ">Basic Information</h3> -->
          <h3 class="flex-1 text-lg font-bold">

{{
stepDetails?.step_mapping?.scheme?.code === 'makeiii'
? '2. Brief Description'
: (isMakeIorII()
? '2. Brief Description / How Is The Requirement Being Met Presently'
: 'Basic Information')
}}

</h3>
          <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['basicInfo']" class="px-5 pb-6 pt-2">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- <div class="flex flex-col">
              <label for="nomenclature" class="mb-2 text-sm font-semibold text-gray-700">
                1.Nomenclature <span class="text-red-500">*</span>
              </label>
              <input
                pInputText
                id="nomenclature"
                formControlName="nomenclature"
                autocomplete="off"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none"
              />
            </div> -->
            <!-- <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'" class="flex flex-col">
              <label class="mb-2 text-sm font-semibold text-blue-700">Dual Use Technology</label>
              <div class="flex gap-8 items-center">
                <div class="inline-flex items-center gap-2">
                  <p-checkbox [binary]="true" inputId="dual_technology_yes" [ngModel]="proposalForm.get('dualUseTechnology')?.value === true"
                    (onChange)="onDualUseTechnologyChange(true)" [ngModelOptions]="{standalone: true}"></p-checkbox>
                  <label for="dual_technology_yes" class="cursor-pointer select-none text-sm">Yes</label>
                </div>
                <div class="inline-flex items-center gap-2">
                  <p-checkbox [binary]="true" inputId="dual_technology_no" [ngModel]="proposalForm.get('dualUseTechnology')?.value === false"
                    (onChange)="onDualUseTechnologyChange(false)" [ngModelOptions]="{standalone: true}"></p-checkbox>
                  <label for="dual_technology_no" class="cursor-pointer select-none text-sm">No</label>
                </div>
              </div>
            </div> -->
            <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'" class="flex flex-col md:col-span-2">
              <label for="brief_description" class="mb-1  font-semibold text-gray-700">

                {{this.stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '2.1 Name of the equipment/system/spare
                and where fitted' : '2.1 Brief Description With Technical Details.'}}
              </label>
              <editor [formControlName]="'brief_description'" [init]="init"></editor>


            </div>
            <!-- <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII'"
              class="flex flex-col md:col-span-2">
              <label *ngIf="this.stepDetails?.step_mapping?.scheme?.code !== 'makeiii'" for="requirement_met" class="mb-1  font-semibold text-gray-700">
                2.2 How Is The Requirement Being Met Presently
              </label>
              <editor [formControlName]="'requirement_met'" [init]="init"></editor>


            </div> -->
            <div *ngIf="stepDetails?.step_mapping?.scheme?.code === 'Make I' || 
            stepDetails?.step_mapping?.scheme?.code === 'Make II'" class="flex flex-col md:col-span-2">

              <label for="requirement_met" class="mb-1 font-semibold text-gray-700">
                2.2 How Is The Requirement Being Met Presently
              </label>

              <editor formControlName="requirement_met" [init]="init"></editor>

            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" *ngIf="schemeType == 'rev'">
            <div class="flex flex-col">
              <label for="platform" class="mb-2 text-sm font-semibold text-gray-700">For which Platform</label>
              <input pInputText id="platform" formControlName="platform" autocomplete="off"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
            <div class="flex flex-col">
              <label for="tenderMode" class="mb-2 text-sm font-semibold text-gray-700">Mode of Tender</label>
              <p-dropdown inputId="tenderMode" [options]="tenderModes" formControlName="tenderMode" optionLabel="label"
                optionValue="value" placeholder="Select Mode" [autoDisplayFirst]="false" class="w-full"></p-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!-- dual use technology section -->
      <div *ngIf="schemeType === 'makeI'"
        class="bg-amber-100 border-2 border-gray-300 rounded-lg overflow-hidden transition-all duration-200 hover:shadow-md">

        <!-- Header (Not visually toggle style, but functionality kept) -->
        <div class="p-4 bg-gray-100/90">

          <div class="flex flex-col md:flex-row md:items-center gap-3">

            <!-- Label -->
            <label class="text-sm font-medium text-slate-700 md:w-1/4 whitespace-nowrap">
              3. Dual Use Technology
            </label>

            <!-- Yes / No -->
            <div class="flex-1 flex items-center gap-8">

              <div class="flex items-center gap-2">
                <p-checkbox [binary]="true" inputId="dual_technology"
                  [ngModel]="proposalForm.get('dualUseTechnology')?.value === true"
                  (onChange)="onDualUseTechnologyChange(true)" [ngModelOptions]="{standalone: true}"></p-checkbox>
                <label for="dual_technology" class="cursor-pointer mb-0">Yes</label>
              </div>

              <div class="flex items-center gap-2">

                <p-checkbox [binary]="true" inputId="dual_technology"
                  [ngModel]="proposalForm.get('dualUseTechnology')?.value === false"
                  (onChange)="onDualUseTechnologyChange(false)" [ngModelOptions]="{standalone: true}"></p-checkbox>
                <label for="dual_technology" class="cursor-pointer mb-0">No</label>
              </div>

            </div>

          </div>

        </div>



      </div>

      <!-- === Equipment & System Section === -->
      <div *ngIf="!isMakeScheme()"
        class="border  overflow-hidden shadow-sm bg-white">
        <div
          class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleSection('equipment')">
          <h3 class="flex-1 text-lg font-bold ">Equipment & System</h3>
          <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['equipment'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['equipment']" class="px-5 pb-6 pt-2">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="flex flex-col">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                Equipment <span class="text-red-500">*</span>
              </label>
              <p-dropdown formControlName="equipment" [options]="filteredEquipment" placeholder="Select Equipment"
                optionLabel="name" optionValue="id" [filter]="true" filterBy="name" emptyFilterMessage=" "
                appendTo="body" class="w-full">
                <ng-template pTemplate="emptyfilter">
                  <div class="flex flex-column align-items-center gap-2 p-2">
                    <span class="text-sm text-gray-500">No results found</span>
                    <button type="button" class="p-button p-button-sm p-button-outlined p-button-success"
                      (click)="showAddEquipmentDialog = true" style="font-size: 0.85rem; padding: 0.35rem 0.75rem;">
                      <i class="pi pi-plus mr-1" style="font-size: 0.8rem;"></i> Add New Equipment
                    </button>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <div class="flex flex-col">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                System <span class="text-red-500">*</span>
              </label>
              <p-dropdown formControlName="system" [options]="filteredSystem" placeholder="Select System"
                optionLabel="name" optionValue="id" [filter]="true" filterBy="name" emptyFilterMessage=" "
                appendTo="body" class="w-full">
                <ng-template pTemplate="emptyfilter">
                  <div class="flex flex-column align-items-center gap-2 p-2">
                    <span class="text-sm text-gray-500">No results found</span>
                    <button type="button" class="p-button p-button-sm p-button-outlined p-button-success"
                      (click)="showAddSystemDialog = true" style="font-size: 0.85rem; padding: 0.35rem 0.75rem;">
                      <i class="pi pi-plus mr-1" style="font-size: 0.8rem;"></i> Add New System
                    </button>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- === Quantity Section === -->
      <div class="border  overflow-hidden shadow-sm bg-white">
        <div *ngIf="schemeType !== 'rev'"
          class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleSection('quantity')">
          <h3 class="flex-1 text-lg font-bold "> {{schemeType === 'makeI' ? '4. Quantity Required' : '3. Quantity Required'}}</h3>
          <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['quantity'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['quantity']" class="px-5 pb-6 pt-2">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div class="flex flex-col" *ngIf="schemeType === 'rev'">
              <label class="mb-2 text-sm font-semibold text-blue-700">Quantity Required<span
                  class="text-red-500">*</span></label>
              <input pInputText formControlName="qtyReqd" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
            <div class="flex flex-col">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                {{
                (schemeType === 'makeII' || schemeType === 'makeIII')
                ? '3.1 Quantity Prototype (based on acceptance criteria and tests)'
                : schemeType === 'makeI'
                ? '4.1 Quantity Prototype (based on acceptance criteria and tests)'
                : 'Quantity Prototype'
                }}
                <span class="text-red-500">*</span>
              </label>

              <input pInputText formControlName="qtyPrototype" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
            <div class="flex flex-col">
              <!-- <label class="mb-2 text-sm font-semibold text-blue-700">4.2 Quantity Bulk (MoQ)<span class="text-red-500">*</span></label> -->
              <label class="mb-2 text-sm font-semibold text-blue-700">
                {{
                schemeType === 'makeII'
                ? '3.2 Quantity Bulk (MoQ)'
                : schemeType === 'makeI'
                ? '4.2 Quantity Bulk (MoQ)'
                : 'Quantity Bulk (MoQ)'
                }}
                <span class="text-red-500">*</span>
              </label>

              <input pInputText formControlName="qtyBulk" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
          </div>
        </div>
      </div>

      <!-- === Cost Section === -->
      
      <div *ngIf="false" class="border  overflow-hidden shadow-sm bg-white">
        <div
          class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleSection('cost')">
          <h3 class="flex-1 text-lg font-bold ">
            {{ schemeType === 'rev' ? 'Cost Details' : (schemeType === 'makeII' ? '4. Estimated Cost' : '5. Estimated
            Cost') }}
          </h3>
          <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['cost'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['cost']" class="px-5 pb-6 pt-2">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="flex flex-col">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                {{ schemeType === 'rev' ? 'Estimated Total Cost (in INR)' : (schemeType === 'makeII' ? '4.1 For
                Development Of Prototype' : (schemeType === 'makeI' || schemeType === 'makeIII' ? '5.1 For Development
                Of Prototype' : 'Estimated Development Cost
                (in INR)')) }}
              </label>
              <input pInputText formControlName="estimatedCost" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
            <div class="flex flex-col">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                {{ schemeType === 'rev' ? 'Estimated Unit Cost' : (schemeType === 'makeII' ? '4.2 Unit Cost For Bulk
                Quantity(in INR)' : (schemeType === 'makeI' || schemeType === 'makeIII' ? '5.2 Unit Cost For Bulk
                Quantity(in INR)' : 'Estimated Procurement Cost per
                Unit (in INR)')) }}
              </label>
              <input pInputText formControlName="estimatedUnitCost" autocomplete="off"
                (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>

            <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'"
              class="col-span-1 md:col-span-2 mt-2">
              <h3 class="text-base font-bold text-gray-800">
                {{ schemeType === 'makeII' ? '4.3' : '5.3' }}. Basis of Estimated Cost
              </h3>
            </div>
            <!-- Make I / Make III: detailed sub-items 5.3.1-5.3.4 -->
            <ng-container *ngIf="schemeType === 'makeI' || schemeType === 'makeIII'">
              <div class="flex flex-col">
                <label class="mb-2 text-sm font-semibold text-blue-700">
                  <span>5.3.1</span>
                  Last Purchase Price(in INR)
                </label>
                <input pInputText formControlName="llp" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                  class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
              </div>
              <div class="flex flex-col">
                <label class="mb-2 text-sm font-semibold text-blue-700"> 5.3.2
                  Last Purchase Year</label>
                <p-calendar formControlName="lpyear" view="year" dateFormat="yy"
                  class="w-full border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none"></p-calendar>
              </div>
              <div class="flex flex-col">
                <label class="mb-2 text-sm font-semibold text-blue-700">
                  5.3.3 In Case Similar Development Of The Product Has Been
                  Undertaken Then savings To exchequer
                </label>
                <input pInputText formControlName="exchequer" autocomplete="off"
                  (keypress)="allowOnlyNumbers($event)"
                  class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
              </div>
              <div class="flex flex-col">
                <label class="mb-2 text-sm font-semibold text-blue-700"> 5.3.4
                  POEV</label>
                <input pInputText formControlName="poev" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                  class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
              </div>
            </ng-container>

            <!-- Make II: single LPP / Similar Development field -->
            <div class="flex flex-col" *ngIf="schemeType === 'makeII'">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                LPP / Similar Development
              </label>
              <input pInputText formControlName="llp" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>

            <!-- Rev: Last Purchase Price (no numbering) -->
            <div class="flex flex-col" *ngIf="schemeType === 'rev'">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                Last Purchase Price(in INR)
              </label>
              <input pInputText formControlName="llp" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
            <!-- <div class="flex flex-col" *ngIf="schemeType === 'rev'">
              <label class="mb-2 text-sm font-semibold text-blue-700">
                Last Purchase Year</label>
              <p-calendar formControlName="lpyear" view="year" dateFormat="yy"
                class="w-full border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none"></p-calendar>
            </div> -->

            <div class="flex flex-col"
              *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
              <label class="mb-2 text-sm font-semibold text-blue-700">POEV Cost</label>
              <input pInputText formControlName="poev" autocomplete="off" (keypress)="allowOnlyNumbers($event)"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
            <div class="flex flex-col"
              *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
              <label class="mb-2 text-sm font-semibold text-blue-700">Consignee</label>
              <input pInputText formControlName="consignee" autocomplete="off"
                class="border-2 border-gray-200  px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
            </div>
          </div>
        </div>
      </div>

     <!-- === Newly added cost section above one is not displayed in UI === -->
      <div class="border overflow-hidden shadow-sm bg-white">
  <div
    class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
    (click)="toggleSection('cost')">
    
    <h3 class="flex-1 text-lg font-bold">
      {{
        schemeType === 'rev'
          ? 'Cost Details'
          : (schemeType === 'makeII' || schemeType === 'makeIII'
              ? '4. Estimated Cost'
              : '5. Estimated Cost')
      }}
    </h3>

    <i class="pi transition-transform duration-200"
      [ngClass]="expandedSections['cost'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'">
    </i>
  </div>

  <div *ngIf="expandedSections['cost']" class="px-5 pb-6 pt-2">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

    <div class="flex flex-col">
  <label class="mb-2 text-sm font-semibold text-blue-700">
    {{
      schemeType === 'rev'
        ? 'Estimated Total Cost (in INR)'
        : (schemeType === 'makeI'
            ? '5.1 For Development Of Prototype'
            : '4.1 For Development Of Prototype')
    }}
  </label>

  <!-- makeI, makeII, makeIII -->
  <input *ngIf="schemeType !== 'rev'"
    pInputText formControlName="estimatedDevelopmentCost" autocomplete="off"
    (keypress)="allowOnlyNumbers($event)"
    class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />

  <!-- rev -->
  <input *ngIf="schemeType === 'rev'"
    pInputText formControlName="estimatedCost" autocomplete="off"
    (keypress)="allowOnlyNumbers($event)"
    class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
</div>

      <!-- Unit Cost -->
      <div class="flex flex-col">
        <label class="mb-2 text-sm font-semibold text-blue-700">
          {{
            schemeType === 'rev'
              ? 'Estimated Unit Cost'
              : (schemeType === 'makeI'
                  ? '5.2 Unit Cost For Bulk Quantity(in INR)'
                  : (schemeType === 'makeII' || schemeType === 'makeIII'
                      ? '4.2 Unit Cost For Bulk Quantity(in INR)'
                      : 'Estimated Procurement Cost per Unit (in INR)'))
          }}
        </label>
        <input pInputText formControlName="estimatedUnitCost" autocomplete="off"
          (keypress)="allowOnlyNumbers($event)"
          class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
      </div>

      <!-- Basis of Estimated Cost Heading -->
      <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'"
        class="col-span-1 md:col-span-2 mt-2">
        <h3 class="text-base font-bold text-gray-800">
          {{
            (schemeType === 'makeII' || schemeType === 'makeIII')
              ? '4.3'
              : '5.3'
          }}. Basis of Estimated Cost
        </h3>
      </div>

      <!-- Make I ONLY: detailed fields -->
      <ng-container *ngIf="schemeType === 'makeI'">
        <div class="flex flex-col">
          <label class="mb-2 text-sm font-semibold text-blue-700">
            5.3.1 Last Purchase Price(in INR)
          </label>
          <input pInputText formControlName="llp" autocomplete="off"
            (keypress)="allowOnlyNumbers($event)"
            class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
        </div>

        <div class="flex flex-col">
          <label class="mb-2 text-sm font-semibold text-blue-700">
            5.3.2 Last Purchase Year
          </label>
          <p-calendar formControlName="lpyear" view="year" dateFormat="yy"
            class="w-full border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none">
          </p-calendar>
        </div>

        <div class="flex flex-col">
          <label class="mb-2 text-sm font-semibold text-blue-700">
            5.3.3 In Case Similar Development Of The Product Has Been Undertaken Then savings To exchequer
          </label>
          <input pInputText formControlName="exchequer" autocomplete="off"
            (keypress)="allowOnlyNumbers($event)"
            class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
        </div>

        <div class="flex flex-col">
          <label class="mb-2 text-sm font-semibold text-blue-700">
            5.3.4 POEV
          </label>
          <input pInputText formControlName="poev" autocomplete="off"
            (keypress)="allowOnlyNumbers($event)"
            class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
        </div>
      </ng-container>

      <!-- Make II + Make III -->
      <div class="flex flex-col" *ngIf="schemeType === 'makeII' || schemeType === 'makeIII'">
        <label class="mb-2 text-sm font-semibold text-blue-700">
          LPP / Similar Development
        </label>
        <input pInputText formControlName="llp" autocomplete="off"
          (keypress)="allowOnlyNumbers($event)"
          class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
      </div>

      <!-- Rev -->
      <div class="flex flex-col" *ngIf="schemeType === 'rev'">
        <label class="mb-2 text-sm font-semibold text-blue-700">
          Last Purchase Price(in INR)
        </label>
        <input pInputText formControlName="llp" autocomplete="off"
          (keypress)="allowOnlyNumbers($event)"
          class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
      </div>

      <!-- <div class="flex flex-col" *ngIf="schemeType === 'rev'">
        <label class="mb-2 text-sm font-semibold text-blue-700">
          Last Purchase Year
        </label>
        <p-calendar formControlName="lpyear" view="year" dateFormat="yy"
          class="w-full border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none">
        </p-calendar>
      </div> -->

      <!-- Others -->
      <div class="flex flex-col"
        *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
        <label class="mb-2 text-sm font-semibold text-blue-700">POEV Cost</label>
        <input pInputText formControlName="poev" autocomplete="off"
          (keypress)="allowOnlyNumbers($event)"
          class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
      </div>

      <div class="flex flex-col"
        *ngIf="schemeType != 'makeI' && schemeType != 'makeII' && schemeType != 'makeIII'">
        <label class="mb-2 text-sm font-semibold text-blue-700">Consignee</label>
        <input pInputText formControlName="consignee" autocomplete="off"
          class="border-2 border-gray-200 px-3 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none" />
      </div>

    </div>
  </div>
      </div>

      <!-- === Justification Section for make schemes === -->
      <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'"
        class="border  overflow-hidden shadow-sm bg-white">
        <div
          class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleSection('justification')">
          <h3 class="flex-1 text-lg font-bold ">
            {{ schemeType === 'makeI' ? '6. Justification To Progress The Case Under Make 1 Category' :
            this.stepDetails?.step_mapping?.scheme?.code === 'Make II'
            ? '5. Justification To Progress The Case Under Make 2 Category' : '5. Justification To Progress The
            Case Under Make 3 Category'}}
          </h3>
          <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['justification'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['justification']" class="px-5 pb-6 pt-2">
          <div>
            <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'" class="flex flex-col mt-3">
              <label class="mb-2 text-sm font-semibold text-blue-700">
             

              {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '5.1 Item already held in Inventory requiring Import substitution.'
        : schemeType === 'makeII'
        ? '5.1 Advantage of availability of technology indigenously designed product'
        : schemeType === 'makeI'
        ? '6.1 Advantage of availability of technology indigenously designed product'
        : ''
    }}
                
                
                
              </label>
              <editor [init]="init" formControlName="indigenously_designed"></editor>
            </div>
            <div class="flex flex-col mt-3" *ngIf="stepDetails?.step_mapping?.scheme?.code !== 'Make II'">
              <label class="mb-2 text-sm font-semibold text-blue-700 ">

                {{ this.stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '5.2. Cost Effectiveness': '6.2
                Avaialability of design capability and infrastructure in India' }}

              </label>
              <editor [init]="init" formControlName="capability_infrastructure"></editor>
            </div>
            <div class="flex flex-col mt-3" *ngIf="this.stepDetails?.step_mapping?.scheme?.code !== 'Make II'">
              <label class="mb-2 text-sm font-semibold text-blue-700">

                {{this.stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? '5.3 Lead time' : '6.3 Is the proposed
                system a part of Long Term Perspective
                Plan(LTPP)'}}
              </label>
              <editor [init]="init" formControlName="ltpp"></editor>
            </div>
          </div>
        </div>
      </div>


      <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'">
        <!-- 7 -->
        <div class="border border-slate-400 rounded-lg bg-[#FEF3C7] p-4 shadow-sm">

          <!-- Label -->
         <label for="lead_development"
  class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

  {{ schemeType === 'makeI' ? '7' : '6' }}.

  {{
    stepDetails?.step_mapping?.scheme?.code === 'makeiii'
      ? 'Vintage and OEM'
      : 'Expected Lead Time for Prototype Development'
  }}

</label>

          <!-- Editor -->
          <editor
    [init]="init"
    [id]="stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? 'vinatge_oem' : 'lead_development'"
    [formControlName]="stepDetails?.step_mapping?.scheme?.code === 'makeiii' ? 'vinatge_oem' : 'lead_development'"
  >
  </editor>

        </div>

        <!-- 8 -->
        <div
          class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg mt-3" *ngIf="this.stepDetails?.step_mapping?.scheme?.code !== 'makeiii'">

          <!-- Toggle Header -->
          <div (click)="toggleSection('requirementIndigenise')"
            class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">

            <h3 class="text-lg font-semibold flex items-center">
              <span class="w-8 h-8 rounded-lg bg-lime-100 text-lime-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-info-circle"></i>
              </span>
              {{ schemeType === 'makeII' ? '7' : '8' }}. Requirement to indigenise the proposed equipment (Details of
              vintage and OEM)


            </h3>

            <i class="pi transition-transform duration-200"
              [ngClass]="expandedSections['requirementIndigenise'] ? 'pi-chevron-down' : 'pi-chevron-right'">
            </i>
          </div>

          <!-- Toggle Content -->
          <div *ngIf="expandedSections['requirementIndigenise']"
            class="px-6 pt-4 pb-6 border-t border-slate-200 space-y-6 animate-fade-in">

            <!-- Editor 1 -->
            <div class="border border-slate-400 rounded-lg p-4 bg-white">
              <label for="indigenise_equipment" class="block text-base text-blue-600 font-semibold mb-3">
                {{ schemeType === 'makeII' ? '7.1' : '8.1' }} In view of obsolescence/ upgradtion/ replacement/ import
                substitution / new induction to counter
                emerging threat perception

              </label>

              <editor [init]="init" id="indigenise_equipment" formControlName="indigenise_equipment">
              </editor>
            </div>


          </div>

        </div>
        <div *ngIf="this.stepDetails?.step_mapping?.scheme?.code === 'makeiii'" >
           <!-- Editor 1 -->
            <div class="border border-slate-400 rounded-lg p-4 bg-white">
              <label for="indigenise_equipment" class="block text-base text-blue-600 font-semibold mb-3">
                7. Requirement of indigenizing existing equipment view obsolescence or upgradation or replacement

              </label>

              <editor [init]="init" id="indigenise_equipment" formControlName="indigenise_equipment">
              </editor>
            </div>
        </div>

        <!-- 9 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
         <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '8. Details of RFI/Market survey undertaken with date and responses therein'
        : (schemeType === 'makeII'
            ? '8. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms) / Details of any collaboration with foreign OEM envisaged'
            : '9. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms)'
          )
    }}

  </label>
          <editor [init]="init" id="rfi_indigenous" formControlName="rfi_indigenous">
          </editor>
        </div>
        
        <div
          class="bg-amber-100 border-2 border-gray-300 overflow-hidden transition-all duration-200 hover:shadow-md rounded-lg mt-3" *ngIf="this.stepDetails?.step_mapping?.scheme?.code === 'makeiii'">

          <!-- Toggle Header -->
          <div (click)="toggleSection('manufacture')"
            class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">

            <h3 class="text-lg font-semibold flex items-center">
              <span class="w-8 h-8 rounded-lg bg-lime-100 text-lime-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-info-circle"></i>
              </span>
              9. Proposed to manufacture in India through which firms (with details)/franchises of OEM/Details of market survey undertaken


            </h3>

            <i class="pi transition-transform duration-200"
              [ngClass]="expandedSections['manufacture'] ? 'pi-chevron-down' : 'pi-chevron-right'">
            </i>
          </div>

          <!-- Toggle Content -->
          <div *ngIf="expandedSections['manufacture']"
            class="px-6 pt-4 pb-6 border-t border-slate-200 space-y-6 animate-fade-in">

            <!-- Editor 1 -->
            <div class="border border-slate-400 rounded-lg p-4 bg-white">
              <label for="indigenise_equipment" class="block text-base text-blue-600 font-semibold mb-3">
                9.1. Confirmation from at least one known MSME or vendor that the equipment/system can be developed and manufactured in India as per design of OEM with minimum 60% Indigenous Content

              </label>

              <editor [init]="init" id="collaboration_envisaged" formControlName="collaboration_envisaged">
              </editor>
            </div>


          </div>

        </div>

        <!-- 10 - Make I only (combined into item 8 for Make II) -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3" *ngIf="schemeType === 'makeI'">
          <label
            class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
            10. Details of any collaboration envisaged with foreign partner
            (If yes, details to be provided)
          </label>
          <editor [init]="init" id="collaboration_envisaged" formControlName="collaboration_envisaged">
          </editor>
        </div>

        <!-- 11 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
          <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '10. Confirmation of at least one Indian Entity/firm ready to undertake JV/ToT with Foreign OEM'
        : (schemeType === 'makeII'
            ? '9. Confirmation that indigenisation is not being undertaken through DRDO/PSU'
            : '11. Confirmation that indigenisation is not being undertaken through DRDO/PSU or IA/IAF (If indigenisation has been attempted previously then the bottleneck that the present proposal aims to overcome)'
          )
    }}

  </label>
          <editor [init]="init" id="drdo_psu" formControlName="drdo_psu">
          </editor>
        </div>

        <!-- 12 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
          <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '11. Details of technical specifications of the equipment/ system/ spare'
        : (schemeType === 'makeII'
            ? '10. Details of technical specifications of the equipment/system / Role of the proposed item/ system in overall operational strategy'
            : '12. Details of technical specifications of the equipment/system'
          )
    }}

  </label>
          <editor [init]="init" id="technical_specifications" formControlName="technical_specifications">
          </editor>
        </div>

        <!-- 13 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
           <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '12. Details of operational requirements of the equipment/system/spare'
        : (schemeType === 'makeII'
            ? '11. Details of operational requirements of the equipment'
            : '13. Details of operational requirements of the equipment / Role of proposed item in overall operation strategy'
          )
    }}

  </label>
          <editor [init]="init" id="operationalRequirements" formControlName="operationalRequirements">
          </editor>
        </div>

        <!-- 14 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
          <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '13. Availability of drawings/manuals/technical documentation'
        : (stepDetails?.step_mapping?.scheme?.code === 'Make II'
            ? '12. Availability of drawings/manuals/technical documentation'
            : '14. Availability of drawings/manuals/technical documentation'
          )
    }}

  </label>
          <editor [init]="init" id="drawings_manuals" formControlName="drawings_manuals">
          </editor>
        </div>

        <!-- 15 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
          <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '14'
        : (schemeType === 'makeII' ? '13' : '15')
    }}. Availability of sample for indigenisation (if required)

  </label>
          <editor [init]="init" id="sample_indigenisation" formControlName="sample_indigenisation">
          </editor>
        </div>

        <!-- 16 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
           <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '15. Confirmation if project is included in Annual Acquisition Plan'
        : (schemeType === 'makeII'
            ? '14. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan'
            : '16. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan'
          )
    }}

  </label>
          <editor [init]="init" id="annual_Acquisition" formControlName="annual_Acquisition">
          </editor>
        </div>

        <!-- 17 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
          <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '16'
        : (schemeType === 'makeII' ? '15' : '17')
    }}. List and venue of likely trials and environmental tests / Type IAW MIL or other standards

  </label>
          <editor [init]="init" id="trials_environments" formControlName="trials_environments">
          </editor>
        </div>

        <!-- 18 -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
         <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '17'
        : (schemeType === 'makeII' ? '16' : '18')
    }}. Availability of photograph of item

  </label>
          <editor [init]="init" id="photograph_item" formControlName="photograph_item">
          </editor>
        </div>

        <!-- 19 - Make I only -->
        <div class="bg-[#FEF3C7] border border-slate-300 rounded-lg shadow-sm p-5 mt-3" *ngIf="schemeType === 'makeI'">
          <label
            class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
            19. Any envisaged export potential of the equipment/system
            (For viability of the proposal to be taken under Make I category)
          </label>
          <editor [init]="init" id="export_potential" formControlName="export_potential">
          </editor>
        </div>






      </div>




      <!-- === Detailed Information Section (not shown for makeII) === -->
      <div class="border  overflow-hidden shadow-sm bg-white" *ngIf="schemeType !== 'makeII' && schemeType !== 'makeIII'">
        <div
          class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleSection('detailedInfo')">
        <h3 class="flex-1 text-lg font-bold">
    {{ schemeType === 'makeI' ? '20 Draft Project Report/Feasibility Report' 
    : (schemeType === 'rev' ? 'Detailed Information' : '') }}
  </h3>
          <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['detailedInfo']" class="px-5 pb-6 pt-2 space-y-4">
          <div *ngIf="schemeType == 'rev'" class="flex flex-col">
            <div class="grid grid-cols-1 gap-4" *ngIf="expandedSections['detailedInfo']">
              <div class="flex flex-col ">
                <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
                  Brief Description/Technical Details
                </label>
                <div class="rounded-b border border-blue-200 bg-white">
                  <editor [init]="init" formControlName="technical_details"></editor>
                </div>
              </div>
              <div class="flex flex-col ">
                <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
                  Justification for mode of tender
                </label>
                <div class="rounded-b border border-blue-200 bg-white">
                  <editor [init]="init" formControlName="justificationText"></editor>
                </div>
              </div>
              <div class="flex flex-col ">
                <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
                  Any export potential of the proposed item
                </label>
                <div class="rounded-b border border-blue-200 bg-white">
                  <editor [init]="init" formControlName="exportPotential"></editor>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="schemeType === 'makeI' || schemeType === 'makeIII'">
            <div>

              <!-- 20 -->

              <div class="flex flex-col mt-3  ">
                <label class="mb-2 text-sm font-semibold text-blue-700">20.1 Description of critical technology
                  required</label>
                <editor [init]="init" formControlName="critical_technology"></editor>
              </div>
              <div class="flex flex-col mt-3">
                <label class="mb-2 text-sm font-semibold text-blue-700">20.2 Infrastructure required/Available with
                  DRDO/Services/PSU</label>
                <editor [init]="init" formControlName="drdo_infrastructure"></editor>
              </div>
              <div class="flex flex-col mt-3">
                <label class="mb-2 text-sm font-semibold text-blue-700"> 20.3 Infrastructure required for trials</label>
                <editor [init]="init" formControlName="trial_infrastructure"></editor>
              </div>


            </div>
          </ng-container>
        </div>
      </div>



      <div *ngIf="schemeType === 'makeI' || schemeType === 'makeII' || schemeType === 'makeIII'">
        <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
          <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '18. Confirmation that the indigenization is not being undertaken through DRDO/PSU'
        : (schemeType === 'makeII'
            ? '17. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.'
            : '21. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.'
          )
    }}

  </label>
          <editor [init]="init" id="project_similar" formControlName="project_similar">
          </editor>
        </div>

        <!-- Make I order: APSO (22) then Nodal Officer (23) -->
        <ng-container *ngIf="schemeType !== 'makeII' && schemeType !== 'makeIII'">
          <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
            <label
              class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
              22. Approval and priority from APSO concerned for case under Make I category
            </label>
            <editor [init]="init" id="approval_apso" formControlName="approval_apso">
            </editor>
          </div>

          <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
            <label
              class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
              23. Details of nodal officer execute the project through the Capital Route under MAKE I category from user
              Dte.
            </label>
            <editor [init]="init" id="nodal_officer_details" formControlName="nodal_officer_details">
            </editor>
          </div>
        </ng-container>

        <!-- Make II order: Nodal Officer (18) then APSO (19) then Revenue/iDEX (20) -->
        <ng-container *ngIf="schemeType === 'makeII' || schemeType === 'makeIII'">
          <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
           <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '19. Details of nodal officer execute the project through the Capital Route under MAKE III category from user Dte.'
        : '18. Details of nodal officer execute the project through the Capital Route under MAKE II category from user Dte.'
    }}

  </label>
            <editor [init]="init" id="nodal_officer_details_make2" formControlName="nodal_officer_details">
            </editor>
          </div>

          <div class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
            <label
    class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">

    {{
      stepDetails?.step_mapping?.scheme?.code === 'makeiii'
        ? '20. Approval and priority from APSO concerned for each of the cases to be fielded under Make III category'
        : '19. Approval and priority from APSO concerned for case to be fielded under MAKE II Category'
    }}

  </label>
            <editor [init]="init" id="approval_apso_make2" formControlName="approval_apso">
            </editor>
          </div>

          <div *ngIf="stepDetails?.step_mapping?.scheme?.code !== 'makeiii'" class="bg-amber-100 border border-slate-300 rounded-lg shadow-sm p-5 mt-3">
            <label
              class="block text-sm font-semibold text-[#2563EB] border-t border-l border-r border-[#2563EB] p-2 rounded-t-lg">
              20. Is Item under Revenue/iDEX procurement?
            </label>
            <editor [init]="init" id="revenue_idex" formControlName="revenue_idex">
            </editor>
          </div>
        </ng-container>
      </div>

      <!-- === File Upload Section === -->
      <div class="border  overflow-hidden shadow-sm bg-white">
        <div
          class="flex items-center cursor-pointer px-5 py-4 bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleSection('uploads')">
          <h3 class="flex-1 text-lg font-bold ">Document Uploads</h3>
          <i class="pi transition-transform duration-200"
            [ngClass]="expandedSections['uploads'] ? 'pi-chevron-down rotate-180' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="expandedSections['uploads']" class="px-5 pb-6 pt-2">
          <div>
            <ng-container *ngIf="['makeI_02'].includes(stepDetails.code); else otherSteps">
              <app-upload-document [isEditable]="stepDetails?.can_edit" [proposal_step]="stepDetails?.id - 1">
              </app-upload-document>
            </ng-container>
            <ng-template #otherSteps>
              <app-upload-document [isEditable]="stepDetails?.can_edit" [proposal_step]="id" [dmsFiles]="allDmsFiles"
                [useParentDmsFiles]="allDmsFiles?.length > 0">
              </app-upload-document>
            </ng-template>
          </div>
          <!-- Upload Progress Indicator -->
          <div class="mt-4 w-full" *ngIf="uploadProgress > 0">
            <div class="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
              <div class="bg-green-500 h-3 transition-all duration-200" [style.width.%]="uploadProgress">
              </div>
            </div>
            <div class="mt-1 text-xs text-center text-gray-600 font-medium">{{ uploadProgress }}%</div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Add New Equipment Dialog -->
  <p-dialog header="Add New Equipment" [(visible)]="showAddEquipmentDialog" [modal]="true" [style]="{ width: '28rem' }"
    [draggable]="false" [resizable]="false">
    <div class="p-fluid">
      <div class="mb-3">
        <label for="newEquipmentName" class="font-medium text-sm mb-2 d-block">Equipment Name <span
            class="text-red-500">*</span></label>
        <input pInputText id="newEquipmentName" [(ngModel)]="newEquipmentName" [ngModelOptions]="{standalone: true}"
          placeholder="Enter equipment name"
          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="p-button p-button-sm p-button-text"
          (click)="showAddEquipmentDialog = false; newEquipmentName = ''">Cancel</button>
        <button type="button" class="p-button p-button-sm p-button-success" [disabled]="!newEquipmentName?.trim()"
          (click)="addNewEquipment()">
          <i class="pi pi-check mr-1"></i> Save
        </button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Add New System Dialog -->
  <p-dialog header="Add New System" [(visible)]="showAddSystemDialog" [modal]="true" [style]="{ width: '28rem' }"
    [draggable]="false" [resizable]="false">
    <div class="p-fluid">
      <div class="mb-3">
        <label for="newSystemName" class="font-medium text-sm mb-2 d-block">System Name <span
            class="text-red-500">*</span></label>
        <input pInputText id="newSystemName" [(ngModel)]="newSystemName" [ngModelOptions]="{standalone: true}"
          placeholder="Enter system name"
          class="w-full px-2.5 py-2.5 border-2 border-slate-500 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="p-button p-button-sm p-button-text"
          (click)="showAddSystemDialog = false; newSystemName = ''">Cancel</button>
        <button type="button" class="p-button p-button-sm p-button-success" [disabled]="!newSystemName?.trim()"
          (click)="addNewSystem()">
          <i class="pi pi-check mr-1"></i> Save
        </button>
      </div>
    </ng-template>
  </p-dialog>